import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Users, MapPin, Anchor, Zap, Ship, Award } from 'lucide-react';
export const WhyKevinBoats = () => {
  const {
    t
  } = useLanguage();
  const cards = [{
    icon: Users,
    titleKey: 'why.c1.title',
    descKey: 'why.c1.desc'
  }, {
    icon: MapPin,
    titleKey: 'why.c2.title',
    descKey: 'why.c2.desc'
  }, {
    icon: Anchor,
    titleKey: 'why.c3.title',
    descKey: 'why.c3.desc'
  }, {
    icon: Zap,
    titleKey: 'why.c4.title',
    descKey: 'why.c4.desc'
  }, {
    icon: Ship,
    titleKey: 'why.c5.title',
    descKey: 'why.c5.desc'
  }, {
    icon: Award,
    titleKey: 'why.c6.title',
    descKey: 'why.c6.desc'
  }];
  return <section className="py-12 sm:py-16 md:py-20 bg-card" data-id="element-567" data-mp="czyb4ialyl3i">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-568" data-mp="cydg6rkdt054">
        <div className="text-center mb-10 sm:mb-16" data-id="element-569" data-mp="8zw742hehfl2">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-570" data-mp="2pnhqtowqnbo3">
            {t('why.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 lg:gap-8" data-id="element-571" data-mp="2tq4kzwgvt8og">
          {cards.map((card, index) => {
          const Icon = card.icon;
          return <div key={index} className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-572" data-mp="33oam4buv6as9" data-mpi={index}>
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-turquoise/10 flex items-center justify-center mb-4 sm:mb-6" data-id="element-573" data-mp="3cn5t3q5qfowm">
                  <Icon className="w-6 h-6 sm:w-7 sm:h-7 text-turquoise" data-id="element-574" data-mp="3hffrlukwxxai" />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-navy mb-2 sm:mb-3" data-id="element-575" data-mp="3md8tibf6o54z">
                  {t(card.titleKey)}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-576" data-mp="6an3m7adfqs">
                  {t(card.descKey)}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
};